export const api = {
    async get(uri) {
        return await fetch(`index.php?route=${uri}`, {
            method: 'get',
        }).then(async (data) => {
            return data;
        })
    },
    async post(uri, body) {
        return await fetch(`index.php?route=${uri}`, {
            method: 'post',
            headers: {
                "Content-type": "application/x-www-form-urlencoded; charset=UTF-8"
            },
            body: body
        }).then(async (data) => {
            return data.json();
        })
    },
    async lget(uri) {
        return await fetch(uri, {
            method: 'get',
        }).then(async (data) => {
            return data;
        })
    },
    async lpost(uri, body) {
        return await fetch(uri, {
            method: 'post',
            headers: {
                "Content-type": "application/x-www-form-urlencoded; charset=UTF-8"
            },
            body: body
        }).then(async (data) => {
            return data.json();
        })
    }
}